import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0 28px 0;
  min-height: 400px;

  .title {
    width: 180px;
    height: 28px;
    margin-bottom: 20px;
  }

  .subtitle {
    width: 390px;
    height: 20px;
    margin-bottom: 26px;
  }

  .contract {
    width: 624px;
    height: 98px;
    margin-bottom: 20px;
  }

  @media screen and (max-width: 960px) {
    padding: 0px 20px 32px 20px;
    border-radius: 0;
    margin-top: 0px;

    .title {
      width: 155px;
    }

    .subtitle {
      width: 335px;
    }

    .contract {
      width: 335px;
      height: 163px;
    }
  }
`;

export const Container = styled.div`
  width: 624px;
  padding: 20px;

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const Title = styled.h2`
  font-weight: 700;
  font-size: 28px;
  color: ${(props) => props.theme.colors.primaryDark2};
  text-align: center;
  margin-bottom: 8px;

  @media screen and (max-width: 960px) {
    font-size: 24px;
    margin-bottom: 12px;
  }
`;

export const Subtitle = styled.h2`
  font-weight: 400;
  font-size: 16px;
  color: ${(props) => props.theme.colors.black};
  text-align: center;
  margin-bottom: 28px;

  @media screen and (max-width: 960px) {
    font-size: 16px;
    margin-bottom: 28px;
  }
`;

export const CardContainer = styled.div`
  width: 100%;
  min-height: 98px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  padding: 20px 40px;
  color: ${(props) => props.theme.colors.gray};
  cursor: pointer;
  margin-bottom: 12px;

  .left {
    display: flex;
    flex-direction: column;
  }

  .right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .portion {
    font-weight: 900;
    font-size: 14px;
    color: ${(props) => props.theme.colors.primaryDark2};
    display: flex;

    #icon {
      display: block;
      margin-right: 2px;
      margin-top: -2px;
    }
  }

  .default {
    font-weight: 400;
    font-size: 12px;
    margin-top: 4px;
    line-height: 18.2px;
  }

  .price {
    font-weight: 700;
    font-size: 20px;
    color: ${(props) => props.theme.colors.primaryDark2};
    line-height: 24.14px;
    display: flex;

    span {
      display: none;
      margin-right: 4px;
    }
  }

  .text {
    font-weight: 400;
    font-size: 12px;
    margin-bottom: 4px;
    line-height: 18.2px;
    display: block;
  }

  .bank {
    font-weight: 700;
    font-size: 14px;
    margin-top: 4px;
  }

  .row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  @media screen and (max-width: 960px) {
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    padding: 24px 20px;
    height: auto;
    justify-content: initial;
    /* flex-direction: column-reverse; */

    .right {
      align-items: flex-start;
    }

    .price {
      font-size: 20px;
      line-height: 20.12px;

      span {
        display: block;
      }
    }

    .portion {
      font-size: 16px;
      line-height: 20.8px;

      #icon {
        display: none;
      }
    }

    .bank {
      margin-bottom: 8px;
    }

    .text {
      display: none;
    }

    .row {
      flex-direction: column-reverse;
    }
  }
`;

export const ContractDescription = styled.span`
  margin-left: 16px;
  word-wrap: break-word;
  padding-top: 4px;

  @media screen and (max-width: 960px) {
    padding-top: 2px;
  }
`;
